import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUzbekistan = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_1153)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M0.566625 8.34788C0.199031 9.4995 -4.68667e-05 10.7264 8.276e-09 11.9999C-4.68667e-05 13.2735 0.199078 14.5005 0.566672 15.6521L12 16.1739L23.4333 15.6522C23.8009 14.5005 24 13.2735 24 12C24 10.7264 23.8009 9.4995 23.4333 8.34783L12 7.82611L0.566625 8.34788Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.4333 8.34788L12 7.82616L0.566622 8.34788C0.457685 8.68931 0.363888 9.03745 0.285278 9.39136H23.7145C23.636 9.03741 23.5423 8.68922 23.4333 8.34788Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.2854 14.6086C0.363916 14.9625 0.457713 15.3106 0.56665 15.6521L0.567775 15.6521L11.9999 16.1738L23.4333 15.6521C23.5422 15.3107 23.636 14.9625 23.7145 14.6086H0.2854Z",
				fill: "#D80027"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9999 24C17.3538 24 21.888 20.4936 23.4333 15.6521H0.56665C2.11189 20.4935 6.6462 24 11.9999 24Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 4.57768e-05C6.64619 9.26518e-05 2.11198 3.50648 0.56665 8.34787L23.4333 8.34792C21.8881 3.50643 17.3538 -1.09813e-06 12 4.57768e-05Z",
				fill: "#338AF3"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M5.48376 4.95659C5.48376 3.83267 6.27365 2.89376 7.32848 2.66342C7.16638 2.62798 6.99815 2.60881 6.82537 2.60881C5.52871 2.60881 4.47754 3.65994 4.47754 4.95664C4.47754 6.25334 5.52862 7.30447 6.82537 7.30447C6.99815 7.30447 7.16634 7.28525 7.32848 7.24986C6.2737 7.01942 5.48376 6.08051 5.48376 4.95659Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M8.71616 6.02377L8.87507 6.51291H9.38938L8.97332 6.81526L9.13222 7.3044L8.71616 7.0021L8.3 7.3044L8.45896 6.81526L8.04285 6.51291H8.55716L8.71616 6.02377Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3577 6.02377L10.5166 6.51291H11.0309L10.6148 6.81526L10.7738 7.3044L10.3577 7.0021L9.94156 7.3044L10.1005 6.81526L9.68445 6.51291H10.1987L10.3577 6.02377Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9994 6.02377L12.1583 6.51291H12.6726L12.2565 6.81526L12.4154 7.3044L11.9994 7.0021L11.5832 7.3044L11.7422 6.81526L11.326 6.51291H11.8404L11.9994 6.02377Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.641 6.02377L13.7999 6.51291H14.3142L13.8981 6.81526L14.0571 7.3044L13.641 7.0021L13.2248 7.3044L13.3838 6.81526L12.9677 6.51291H13.482L13.641 6.02377Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2825 6.02377L15.4414 6.51291H15.9557L15.5397 6.81526L15.6986 7.3044L15.2825 7.0021L14.8664 7.3044L15.0253 6.81526L14.6093 6.51291H15.1235L15.2825 6.02377Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M10.3577 4.31625L10.5166 4.80535H11.0309L10.6148 5.10774L10.7738 5.59683L10.3577 5.29453L9.94156 5.59683L10.1005 5.10774L9.68445 4.80535H10.1987L10.3577 4.31625Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9994 4.31625L12.1583 4.80535H12.6726L12.2565 5.10774L12.4154 5.59683L11.9994 5.29453L11.5832 5.59683L11.7422 5.10774L11.326 4.80535H11.8404L11.9994 4.31625Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.641 4.31625L13.7999 4.80535H14.3142L13.8981 5.10774L14.0571 5.59683L13.641 5.29453L13.2248 5.59683L13.3838 5.10774L12.9677 4.80535H13.482L13.641 4.31625Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2825 4.31625L15.4414 4.80535H15.9557L15.5397 5.10774L15.6986 5.59683L15.2825 5.29453L14.8664 5.59683L15.0253 5.10774L14.6093 4.80535H15.1235L15.2825 4.31625Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.9994 2.60869L12.1583 3.09788H12.6726L12.2565 3.40017L12.4154 3.88936L11.9994 3.58706L11.5832 3.88936L11.7422 3.40017L11.326 3.09788H11.8404L11.9994 2.60869Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.641 2.60869L13.7999 3.09788H14.3142L13.8981 3.40017L14.0571 3.88936L13.641 3.58706L13.2248 3.88936L13.3838 3.40017L12.9677 3.09788H13.482L13.641 2.60869Z",
				fill: "#F0F0F0"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M15.2825 2.60869L15.4414 3.09788H15.9557L15.5397 3.40017L15.6986 3.88936L15.2825 3.58706L14.8664 3.88936L15.0253 3.40017L14.6093 3.09788H15.1235L15.2825 2.60869Z",
				fill: "#F0F0F0"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_1153",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgUzbekistan;
